module.exports = __webpack_public_path__ + "img/didar.67ebb8d7.gif";